const restaurant = {
  restaurant: "Ristorante", // translated
  restaurants: "Ristoranti", // translated
  category: "Categoria", // translated
  score: "Punto", // translated
  priceQuartile: "Quartile del prezzo", // translated
  scoreLowestFirst: "Punteggio (prima il più basso)", // translated
  scoreHighestFirst: "Punteggio (prima il più alto)", // translated
  priceLowestFirst: "Prezzo (prima il più basso)", // translated
  priceHighestFirst: "Prezzo (prima il più alto)", // translated
  allPrices: "Tutti i prezzi", // translated
  reserve: "Riserva", // translated
  dining: "Cenare", // translated
};

export default restaurant;
